import styled from 'styled-components';

export interface TextWithLimitedWidthProps {
  maxWidth?: string;
}

export const Label = styled.label`
  font-size: 14px;
  font-weight: normal;
`;

export const LabelBold = styled.label`
  font-size: 14px;
  font-weight: 500;
`;

export const TextWithLimitedWidth = styled.span<TextWithLimitedWidthProps>`
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '100%')};
  display: block;
  word-break: break-all;
`;

export default Label;
